import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';

import { AlertService } from '../../shared-services/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { SecurityService } from 'src/app/shared-services/services/security.service';

@Component({
    selector: 'app-welcome',
    templateUrl: './welcome.component.html'
})
export class WelcomeComponent implements OnInit {
    isAuthenticated$: Observable<boolean>;

    public message: string;
    public version: string;

    constructor(
        private router: Router,
        private alertService: AlertService,
        private securityService: SecurityService,
        public oidcSecurityService: OidcSecurityService) {

        console.log('in welcome component');
        this.message = '';
        this.version = `${environment.version}`;
    }

    ngOnInit() {
        this.isAuthenticated$ = this.oidcSecurityService.isAuthenticated$;

        this.oidcSecurityService.checkAuth().subscribe((isAuthenticated) => console.log('app authenticated', isAuthenticated));
    }

    login() {
        this.oidcSecurityService.authorize();
        // this.router.navigate([`/orders`]);
    }

    logout() {
        this.oidcSecurityService.logoff();
    }
}
